/**
 * Store automation test results per agent.
 * Keyed by agentId so each agent has its own result set.
 */
export default {
	namespaced: true,
	state: {
		resultsByAgentId: {},
	},
	mutations: {
		SET_AGENT_TEST_RESULTS(state, { agentId, results }) {
			if (!agentId) return;
			state.resultsByAgentId = {
				...state.resultsByAgentId,
				[agentId]: results || [],
			};
		},
		CLEAR_AGENT_TEST_RESULTS(state, agentId) {
			if (!agentId) return;
			const next = { ...state.resultsByAgentId };
			delete next[agentId];
			state.resultsByAgentId = next;
		},
	},
	getters: {
		agentTestResults: (state) => (agentId) => {
			if (!agentId) return [];
			return state.resultsByAgentId[agentId] || [];
		},
	},
};
